// MS-710: silent CBE refresh-token redemption.
//
// Two independent call sites need the exact same "try one silent refresh" logic —
// lib/api.ts's 401 interceptor and AuthProvider's mount-time session probe — so this
// is a dedicated module rather than living in either, guaranteeing they can't
// silently diverge.
//
// A module-level in-flight promise means several near-simultaneous 401s in one tab
// share a single refresh round trip rather than firing N.

let inFlightRefresh: Promise<boolean> | null = null

async function doRefresh(): Promise<boolean> {
  try {
    const response = await fetch('/api/v1/auth/refresh', {
      method: 'POST',
      credentials: 'include',
    })
    return response.ok
  } catch {
    return false
  }
}

/**
 * Attempt one silent refresh of the Studio session via POST /api/v1/auth/refresh.
 * Resolves true on success, false on any failure (missing/invalid refresh token,
 * CBE unreachable, etc). Never throws.
 */
export function attemptRefresh(): Promise<boolean> {
  if (inFlightRefresh === null) {
    inFlightRefresh = doRefresh().finally(() => {
      inFlightRefresh = null
    })
  }
  return inFlightRefresh
}
